import type * as React from 'react';
import type { FC } from 'react';

import NewArrowRight from '@crehana/icons/NewArrowRight';
import type { BaseCuiFCProps } from '@crehana/ui/dist/helpers/types';
import { white } from '@crehana/ui/dist/styles/colors';
import transition from '@crehana/ui/dist/styles/transition';
import { scrollTop } from '@crehana/utils/scroll';
import cn from 'classnames';

type ScrollTopFABProps = BaseCuiFCProps & {
  onScrollTop?: () => void;
};

const ScrollTopFAB: FC<React.PropsWithChildren<ScrollTopFABProps>> = ({
  className,
  onScrollTop,
  css: cssProp,
  ...scrollTopFABProps
}) => {
  const onClick = () => {
    if (typeof onScrollTop === 'function') {
      onScrollTop();
    } else {
      scrollTop();
    }
  };

  return (
    <button
      type="button"
      className={cn(
        'flex flex-shrink-0 items-center justify-center bg-secondary-main hover:bg-secondary-light w-32 h-32 rounded-full focus:outline-none',
        className,
      )}
      css={`
        transition: ${transition('background-color')};
        & > svg {
          transform: rotate(-90deg);
        }
        ${cssProp}
      `}
      onClick={onClick}
      {...scrollTopFABProps}
    >
      <NewArrowRight color={white} size={16} />
    </button>
  );
};

export default ScrollTopFAB;
